import { Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import { createUseThemedStyles } from '@/hooks';

import { ReactComponent as ConsultationsIcon } from '@/assets/icons/hackett-consultations-icon.svg';
import { ReactComponent as ResearchReportsIcon } from '@/assets/icons/hackett-research-reports-icon.svg';
import { ReactComponent as CustomContentIcon } from '@/assets/icons/hackett-custom-content-icon.svg';

const useStyles = createUseThemedStyles({
	iconOuter: {
		width: 160,
		height: 'auto',
		display: 'block',
		margin: '0 auto 8px',
	},
});

export const VendorEnablement = () => {
	const classes = useStyles();

	return (
		<>
			<Helmet>
				<title>Hackett Connect - Vendor Enablement Program</title>
			</Helmet>

			<Container className="bg-white" fluid>
				<Container className="py-11">
					<Row>
						<Col>
							<h1 className="mb-4 text-primary">Vendor Enablement Program</h1>
							<p>
								Grounded in independent, data-backed insight and a clear understanding of how buyers
								evaluate solutions, the Vendor Enablement Program helps you align messaging, product
								positioning and sales approach to the capabilities and outcomes that matter most -
								enabling you to stand out from competitors and gain visibility with potential buyers.
							</p>
							<p className="mb-0">
								Combining objective performance data, competitive intelligence and expert guidance, the
								program provides a clear view of where you lead, where to differentiate and how to
								translate insight into more effective market engagement and faster deal progression.
							</p>
						</Col>
					</Row>
				</Container>
			</Container>

			<Container className="bg-gray-100" fluid>
				<Container className="py-11">
					<Row className="mb-4">
						<Col>
							<h2 className="mb-4 text-primary">Program Deliverables</h2>
							<p className="mb-0">Members of the Vendor Enablement Program has access to:</p>
						</Col>
					</Row>
					<Row>
						<Col lg={4} className="mb-4">
							<ConsultationsIcon className={classNames(classes.iconOuter, 'text-danger')} />
							<h4 className="mb-2 text-uppercase text-danger text-center">Consultations</h4>
							<p className="mb-0 text-center">
								Regular consultations with The Hackett Group's analysts who can provide deeper knowledge
								of your competency area, market and competitors, as well as advice on product road maps
								and service delivery design
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<ResearchReportsIcon className={classNames(classes.iconOuter, 'text-secondary')} />
							<h4 className="mb-2 text-uppercase text-secondary text-center">Research Reports</h4>
							<p className="mb-0 text-center">
								Relevant research reports, including full versions of software and service vendor
								assessments , process-level best practices and emerging trends
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<CustomContentIcon className={classNames(classes.iconOuter, 'text-warning')} />
							<h4 className="mb-2 text-uppercase text-warning text-center">Custom Content</h4>
							<p className="mb-0 text-center">
								Vendor profiles are showcased on Hackett Connect&reg;, supported by bespoke thought
								leadership and case studies, with opportunities for targeted engagement with buyers
								through event sponsorship or participation
							</p>
						</Col>
					</Row>
				</Container>
			</Container>
		</>
	);
};
